export default __webpack_public_path__ + "static/2-7c63eab6500a508ba2d7f5be7f1bbdee.jpg";